import { sound } from '@pixi/sound'
import type { GameBus } from '../../game/events/GameEvents'

// 音效管理 — 對應 Unity Master Audio + Slot001_Sounds。沿用 Unity 既有音效檔。
const BASE = `${import.meta.env.BASE_URL}audio/`

const SFX = [
  'se_spin',
  'se_stop',
  'se_regularwin',
  'se_button',
  'se_getmoney',
  'se_bonus_enter',
  'se_bonus_win',
  'se_extrabeton',
  'se_wheel',
  'bw_bigwin',
  'bw_megawin',
  'bw_superwin',
  'bw_epicwin',
] as const

const BGM_ALIAS = 'mu_base'

export function loadAudio(): void {
  for (const name of SFX) {
    sound.add(name, { url: `${BASE}${name}.ogg`, preload: true })
  }
  sound.add(BGM_ALIAS, { url: `${BASE}mu_base_background.ogg`, preload: true, loop: true })
}

function play(alias: string, volume = 1): void {
  if (sound.exists(alias)) {
    sound.play(alias, { volume })
  }
}

const TIER_SFX: Record<string, string> = {
  'BIG WIN': 'bw_bigwin',
  'MEGA WIN': 'bw_megawin',
  'SUPER WIN': 'bw_superwin',
  'EPIC WIN': 'bw_epicwin',
}

// 訂閱遊戲事件並播放對應音效（集中管理，取代散落的播放呼叫）。
export class AudioManager {
  private bgmStarted = false

  constructor(bus: GameBus) {
    bus.on('spinRequested', () => {
      this.ensureBgm()
      play('se_button')
    })
    bus.on('spinStarted', () => play('se_spin'))
    bus.on('reelsStopped', () => play('se_stop'))
    bus.on('winShowStarted', () => play('se_regularwin'))
    bus.on('multiplierApplied', () => play('se_getmoney'))
    bus.on('bonusEntered', () => play('se_bonus_enter'))
    bus.on('bigWinShown', ({ tier }) => play(TIER_SFX[tier] ?? 'bw_bigwin'))
    bus.on('betChanged', () => play('se_button'))
    bus.on('turboChanged', () => play('se_button'))
    bus.on('extraBetChanged', () => play('se_extrabeton'))
  }

  // 瀏覽器需使用者互動後才能播放音訊；首次互動時啟動 BGM。
  private ensureBgm(): void {
    if (this.bgmStarted) return
    this.bgmStarted = true
    play(BGM_ALIAS, 0.35)
  }
}
